import React, { useRef, useEffect, useState } from 'react';
import close from '../../assets/icons/close.svg';
import { getData } from '../../API/GlobalApi';
import '../../assets/css/Modal.css';

const ViewAdmissionForm = ({ selectedStudentPrintData, isOpen, onClose }) => {
    const [data, setData] = useState('');
    const [academicData, setAcademicData] = useState(null);

    const printRef = useRef();
    const id = selectedStudentPrintData?.user_id;

    useEffect(() => {
        const fetchStudentDetails = async () => {
            if (!id) return;

            try {

                const [basicData, academicData] = await Promise.all([
                    getData(`students/get-students/${id}/`),
                    getData(`students/students-academic-details/${id}/`)
                ]);

                setData(basicData);          
                setAcademicData(academicData);

            } catch (error) {
               
            }
        };

        fetchStudentDetails();
    }, [id]);

  

    const formattedDOB = data?.date_of_birth
        ? new Date(data.date_of_birth).toLocaleDateString('en-GB')
        : '';

    const currentAddress = data?.addresses?.find(addr => addr.address_type === "Current");
    const mobileNumber = data?.contact_numbers?.find(c => c.contact_type === "Mobile")?.number;

    const handlePrint = () => {
        window.print();
    };

    if (!isOpen) return null;

    return (
        <div id="print-wrap"
            style={{ width: '794px', height: '0', overflow: 'unset' }}>
            <div className="modal-overlay view-admission-print-modal feenotice-overlay">
             <div className="print-area feenotice-print-area">
                    <div className="modal-content admissionformprint mt-1 feenotice-container" ref={printRef}
                        style={{
                            width: '1000px',
                            // height: '700px',
                            overflow: 'hidden',
                            // overflowX:'auto',
                            padding: '20px 40px',
                            boxSizing: 'border-box',
                            margin: 'auto',
                            overflow: 'visible',
                        }}>
                            <div className='feenotice-page'> 
                        <div className="modal-header-content" style={{ position: 'relative', textAlign: 'center' }}>
                            <h2 style={{ fontWeight: 'bold' }} className='collegenameTitle mt-2'>
                                Banaras Institute of Teachers Education, Varanasi
                            </h2>
                            <p style={{ fontStyle: 'italic' }} className='mt-2'>
                                (Affiliated with "Mahatma Gandhi Kashi Vidyapith, Varanasi")
                            </p>
                            <p style={{ fontStyle: 'italic' }}>
                                Application form (2025-26)
                            </p>

                            {/* Close Button - hidden in print */}
                            <button
                                className="close-btn no-print"
                                onClick={onClose}
                                style={{
                                    position: 'absolute',
                                    top: '0',
                                    right: '0',
                                    background: 'none',
                                    border: 'none',
                                    padding: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <img src={close} alt="close" />
                            </button>
                        </div>

                        <div className="modal-body admission-modal-body" style={{ fontSize: '11pt', fontFamily: 'Arial, sans-serif', }}>
                            {/* Header Row */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                                <div>
                                    <p className='registrationNo'><strong>Registration No.:</strong> {data?.permanent_registration_number || '_____________________'}</p>
                                </div>
                                {/* <div
                                style={{
                                    width: '120px',
                                    height: '140px',
                                    textAlign: 'center',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    border: '1px solid #000',
                                    overflow: 'hidden'
                                }}
                            >
                                {/* {data?.profile_picture ? ( 
                                    // <img
                                    //     src={data.profile_picture}
                                    //     alt="Candidate"
                                    //     style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    // />
                                // ) : (

                                    <span style={{ fontSize: '10pt' }}>Candidate Photo</span>
                                {/* } *
                                <span style={{ fontSize: '10pt' }}>Candidate Photo</span>
                            </div> */}
                            </div>

                            <hr />

                            {/* Personal Info */}
                            <div className="row fixed-two-col printadmissionform">
                                <div className="col-5">
                                    <p><strong>Applicant Name:</strong> {(data?.first_name + ' ' + (data?.middle_name || '') + ' ' + data?.last_name)}</p>
                                </div>
                                <div className="col-5">
                                    <p><strong>Name (CAPITAL):</strong> {(data?.first_name + ' ' + (data?.middle_name || '') + ' ' + data?.last_name).toUpperCase()}</p>
                                </div>

                                <div className="col-5">
                                    <p><strong>Father’s Name:</strong> {data?.father_name}</p>
                                </div>
                                <div className="col-5">
                                    <p><strong>Mother’s Name:</strong> {data?.mother_name}</p>
                                </div>

                                <div className="col-5">
                                    <p><strong>Date of Birth:</strong> {formattedDOB}</p>
                                </div>
                                <div className="col-5">
                                    <p><strong>Gender:</strong> {data?.gender}</p>
                                </div>

                                <div className="col-5">
                                    <p><strong>Caste:</strong> {data?.category?.name}</p>
                                </div>
                                <div className="col-5">
                                    <p><strong>Nationality:</strong> Indian</p>
                                </div>
                            </div>


                            <hr />

                            {/* Address */}
                            <div className="mt-4 correspondenceadd ">
                                <h2>Correspondence Address</h2>
                                <div className="row mt-2 fixed-two-col">
                                    <div className="col-12">
                                        <p>
                                            {currentAddress
                                                ? `${currentAddress.address}, ${currentAddress.city?.name} - ${currentAddress.pincode}, ${currentAddress.state?.name}`
                                                : 'N/A'}
                                        </p>
                                    </div>

                                    <div className="col-5 col-sm-5">
                                        <p><strong>Mobile:</strong> {mobileNumber || 'N/A'}</p>
                                    </div>
                                    <div className="col-5 col-sm-6">
                                        <p><strong>Email:</strong> {data?.email || 'N/A'}</p>
                                    </div>
                                </div>

                            </div>

                            <hr />

                            {/* Education Table */}
                            <div className='academicqaualification'>
                                <h2>Academic Qualification</h2>
                                <table className='mt-3' style={{ width: '100%', borderCollapse: 'collapse', fontSize: '10pt' }}>
                                    <thead>
                                        <tr>
                                            {['Exam', 'Board', 'Year', 'Marks(%)', 'Subjects'].map(heading => (
                                                <th key={heading} style={{ border: '1px solid #000', padding: '4px', textAlign: 'left' }}>{heading}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {academicData?.map((row, idx) => (
                                            <tr key={idx}>
                                                <td style={{ border: '1px solid #000', padding: '4px' }}>{row.course_name}</td>
                                                <td style={{ border: '1px solid #000', padding: '4px' }}>{row.board}</td>
                                                <td style={{ border: '1px solid #000', padding: '4px' }}>{row.year_of_admission}-{row?.year_of_passing}</td>
                                                {/* <td style={{ border: '1px solid #000', padding: '4px' }}>{row.roll}</td> */}
                                                <td style={{ border: '1px solid #000', padding: '4px' }}>{row.percentage}</td>
                                                <td style={{ border: '1px solid #000', padding: '4px' }}>
                                                    {row?.qualifying_subjects?.map((subj) => subj.subject).join(', ')}
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <p className='lastinstitute' style={{ marginTop: '20px', textAlign: 'start' }}>
                                <strong>Last Institute Attended:</strong>{' '}
                                {academicData?.find((item) => item.course_name === '12th')?.college || 'N/A'}
                            </p>


                            {/* Signature */}
                            <div className='signature' style={{ textAlign: 'right', marginTop: '40px' }}>
                                <p className='text-end'>Signature of Applicant ____________________</p>
                            </div>
                        </div>
</div>
                        {/* Print Button at Bottom */}
                        <div className="text-end mt-3 no-print">
                            <button onClick={handlePrint} className="btn  btn-sm" style={{background:'#7F56DA',color:'#FFF'}}>Print Form</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewAdmissionForm;
